/* global axios */
import ApiClient from '../ApiClient';

class AnalyticsAPI extends ApiClient {
  constructor() {
    super('pipeline/analytics', { accountScoped: true });
  }

  getWinRate({ startDate, endDate, pipelineId } = {}) {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    if (pipelineId) params.pipeline_id = pipelineId;

    return axios.get(`${this.url}/win_rate`, { params });
  }

  getConversionMetrics({ startDate, endDate, pipelineId }) {
    const params = { pipeline_id: pipelineId };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;

    return axios.get(`${this.url}/conversion_metrics`, { params });
  }

  getSalesVelocity({ startDate, endDate, pipelineId } = {}) {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    if (pipelineId) params.pipeline_id = pipelineId;

    return axios.get(`${this.url}/sales_velocity`, { params });
  }

  getDashboard({ startDate, endDate } = {}) {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;

    return axios.get(`${this.url}/dashboard`, { params });
  }

  getPipelineAnalysis(pipelineId, startDate, endDate) {
    const params = {
      pipeline_id: pipelineId,
    };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;

    return axios.get(`${this.url}/pipeline_analysis`, { params });
  }
}

export default new AnalyticsAPI();
